// extracted by mini-css-extract-plugin
module.exports = {"card":"ShotPreview_card__1umOC"};